// List of UTM parameters to look for
const utmParams = [
  'utm_id',
  'utm_source',
  'utm_referrer',
  'utm_medium',
  'utm_campaign',
  'utm_source_platform',
  'utm_term',
  'utm_content',
  'utm_creative_format',
  'utm_marketing_tactic'
];

/**
 * Retrieves UTM parameters from the current URL.
 * @returns {Object} An object containing available UTM parameters and their values.
 */
export const getUTMParamsFromURL = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmData = {};

  utmParams.forEach(param => {
    if (urlParams.has(param)) {
      utmData[param] = urlParams.get(param);
    }
  });

  return utmData;
};
